module.exports = __webpack_public_path__ + "img/recharge-text-green.45e77b6.svg";